import React from 'react';

const SampleDataGrid = ({ data }) => {
  if (!data || data.length === 0) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>데이터가 없습니다.</div>;
  }

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ backgroundColor: '#f8f9fa' }}>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>시간</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>머신</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>토픽</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>평균온도</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>최소온도</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>최대온도</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>데이터수</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>평균최소임계값</th>
          <th style={{ border: '1px solid #ddd', padding: '8px' }}>평균최대임계값</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {row.timestamp || row.created_at}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.machine}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.topic}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {row.temp ? Number(row.temp).toFixed(2) : '-'}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {row.min ? Number(row.min).toFixed(2) : '-'}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {row.max ? Number(row.max).toFixed(2) : '-'}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{row.count || '-'}</td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {row.avg_min_threshold ? Number(row.avg_min_threshold).toFixed(2) : '-'}
            </td>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
              {row.avg_max_threshold ? Number(row.avg_max_threshold).toFixed(2) : '-'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SampleDataGrid;